<div class="govuk-width-container">
    <div class="row">
        <nav class="col-12 col-md-4" aria-label="Side navigation">
            <p class="govuk-body h-100"><app-menu></app-menu></p>
        </nav>
        <main class="govuk-main-wrapper col-12 col-md-8 pt-0" id="main-content" tabindex="-1">
            <div>
                <h1 class="govuk-heading-xl">Ceremony Checklist</h1>
                <app-custom-object-banner page="ceremony-checklist"></app-custom-object-banner>
                <!-- <p class="govuk-body"><strong>This is your current progress</strong></p> -->
                <ul class="govuk-task-list">
                    <li class="govuk-task-list__item govuk-task-list__item--with-link" *ngIf="(!notice1Given || !notice2Given) && showGiveNotice">
                        <div class="govuk-task-list__name-and-hint">
                            <a href="{{myUrl}}/give-notice" class="govuk-link govuk-task-list__link"
                                aria-describedby="ceremony-details-3-status">
                                <h2>Give notice</h2>
                            </a>
                            <ng-container>
                                <span class="govbook-meta">Due no later than {{ giveNoticeDueDate }}</span>
                                <br>
                                <span class="govbook-meta">This will show as Completed once your given notice appointment has taken place.</span>
                            </ng-container>
                        </div>
                        <div class="govuk-task-list__status" id="ceremony-details-3-status" >
                            <strong class="govuk-tag">
                                Incomplete
                                <i class="ph ph-fill ph-warning-circle" aria-hidden="true"></i>
                            </strong>
                        </div>
                    </li>
                    
                    <ng-container *ngIf="purchase && purchase.price !== purchase.paid">
                        <li class="govuk-task-list__item govuk-task-list__item--with-link">
                            <div class="govuk-task-list__name-and-hint">
                                <a href="{{myUrl}}/payment-information" class="govuk-link govuk-task-list__link"
                                    aria-describedby="ceremony-details-4-status">
                                    <h2>Pay outstanding balance</h2>
                                </a>
                                <ng-container>
                                    <span class="govbook-meta">Due no later than {{ outstandingBalanceDueDate }}</span>
                                </ng-container>
                            </div>
                            <div class="govuk-task-list__status" id="ceremony-details-4-status">
                                <strong class="govuk-tag">
                                    Incomplete
                                    <i class="ph ph-fill ph-warning-circle" aria-hidden="true"></i>
                                </strong>
                                
                            </div>
                        </li>
                    </ng-container>
                    <ng-container *ngIf="!excludedChoicesServiceIds.includes(service.global_id)">
                      <li class="govuk-task-list__item govuk-task-list__item--with-link">
                        <div class="govuk-task-list__name-and-hint">
                            <a href="{{myUrl}}/ceremony-choices" class="govuk-link govuk-task-list__link"
                                aria-describedby="ceremony-details-5-status">
                                <h2>Complete your ceremony choices</h2>
                            </a>
                            <ng-container *ngIf="choicesRequiredCount !== choicesFoundCount">
                                <span class="govbook-meta">Due no later than {{ choicesDueDate }}</span>
                            </ng-container>
                        </div>
                        <div class="govuk-task-list__status" id="ceremony-details-5-status" *ngIf="choicesRequiredCount !== choicesFoundCount">
                            <strong class="govuk-tag" >
                                Incomplete
                                <i class="ph ph-fill ph-warning-circle" aria-hidden="true"></i>
                            </strong>
                            
                        </div>
                      </li>
                    </ng-container>
                </ul>
                <!-- <p class="govuk-body"><strong>Completed</strong></p> -->
                <ul class="govuk-task-list">
                    <li class="govuk-task-list__item govuk-task-list__item--with-link">
                        <div class="govuk-task-list__name-and-hint">
                            <h2 class="govuk-link govuk-task-list__link" aria-describedby="ceremony-details-1-status">Book your venue</h2>
                        </div>
                        <div class="govuk-task-list__status" id="ceremony-details-1-status">
                            <strong class="govuk-tag completed" >
                                Completed
                                <i class="ph-fill ph-check-circle" aria-hidden="true"></i>
                            </strong>
                        </div>
                    </li>
                    <li class="govuk-task-list__item govuk-task-list__item--with-link">
                        <div class="govuk-task-list__name-and-hint">
                            <h2 class="govuk-link govuk-task-list__link" aria-describedby="ceremony-details-2-status">Book your registrars</h2>
                        </div>
                        <div class="govuk-task-list__status" id="ceremony-details-2-status">
                            <strong class="govuk-tag completed" >
                                Completed
                                <i class="ph-fill ph-check-circle" aria-hidden="true"></i>
                            </strong>
                        </div>
                    </li>
                    <li class="govuk-task-list__item govuk-task-list__item--with-link" *ngIf="notice1Given && notice2Given && showGiveNotice">
                        <div class="govuk-task-list__name-and-hint">
                            <a href="{{myUrl}}/give-notice" class="govuk-link govuk-task-list__link"
                                aria-describedby="ceremony-details-3-status">
                                Give notice
                            </a>
                        </div>
                        <div class="govuk-task-list__status" id="ceremony-details-3-status" >
                            <strong class="govuk-tag completed" >
                                Completed
                                <i class="ph-fill ph-check-circle" aria-hidden="true"></i>
                            </strong>
                        </div>
                    </li>
                    <ng-container *ngIf="purchase && purchase.price == purchase.paid">
                        <li class="govuk-task-list__item govuk-task-list__item--with-link">
                            <div class="govuk-task-list__name-and-hint">
                                <a href="{{myUrl}}/payment-information" class="govuk-link govuk-task-list__link"
                                    aria-describedby="ceremony-details-4-status">
                                    <h2>Pay outstanding balance</h2>
                                </a>
                            </div>
                            <div class="govuk-task-list__status" id="ceremony-details-4-status">
                                <span >
                                    <strong class="govuk-tag completed" >
                                        Completed
                                        <i class="ph-fill ph-check-circle" aria-hidden="true"></i>
                                    </strong>
                                </span>
                            </div>
                        </li>
                    </ng-container>
                    <li class="govuk-task-list__item govuk-task-list__item--with-link" *ngIf="choicesRequiredCount === choicesFoundCount">
                        <div class="govuk-task-list__name-and-hint">
                            <a href="{{myUrl}}/ceremony-choices" class="govuk-link govuk-task-list__link"
                                aria-describedby="ceremony-details-5-status">
                                <h2>Complete your ceremony choices</h2>
                            </a>
                        </div>
                        <div class="govuk-task-list__status" id="ceremony-details-5-status" >
                            <strong class="govuk-tag completed" >
                                Completed
                                <i class="ph-fill ph-check-circle" aria-hidden="true"></i>
                            </strong>
                        </div>
                    </li>
                </ul>
            </div>
        </main>
    </div>
</div>